import { motion } from "framer-motion";
import { SectionHeading } from "./Reveal";
import { PRINCIPLES } from "../data/content";

export const WhyFarmint = () => (
  <section id="why" className="relative py-24 sm:py-32" data-testid="why-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <SectionHeading
        index="09"
        eyebrow="Why Farmint"
        title="Why engineering teams choose Farmint."
        sub="Principles we hold on every engagement — no shortcuts, no hand-offs into the void."
      />
      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {PRINCIPLES.map((p, i) => (
          <motion.div
            key={p.title}
            data-testid={`principle-card-${i + 1}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: (i % 3) * 0.09, ease: [0.22, 1, 0.36, 1] }}
            className="group rounded-2xl border hairline bg-card/60 p-7 transition-[border-color] duration-200 hover:border-primary/40"
          >
            <span className="font-mono text-3xl font-semibold text-primary/40 transition-colors duration-300 group-hover:text-primary">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="mt-4 font-display text-lg font-bold tracking-tight">{p.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{p.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
